export const CONFIRM_SITE_ACCESS_HEADING = "confirm-site-access-heading";
export const CONFIRM_SITE_ACCESS_TEXT = "confirm-site-access-text";
export const CONFIRM_SITE_ACCESS_FORM_ID = "confirm-site-access-form";
export const ACCESS_CODE_LABEL = "access-code-label";
export const NEXT_STEP_BUTTON_ID = "next-step-button";
export const ACCESS_CODE_NAME = "accessCode";
export const ACCESS_CODE_REQUIRED_ERROR_MESSAGE =
  "access-code-required-error-message";
export const ACCESS_CODE_INVALID_ERROR_MESSAGE =
  "access-code-invalid-error-message";
export const LOCATION_NPI_NAME = "locationNPI";
export const ACCESS_CODE_EXPIRATION_ERROR = "access-code-expiration-error";
export const ACCESS_CODE_IS_VERIFIED_FALSE_ERROR =
  "access-code-is-verified-false-error";
export const ACCESS_CODE_HELPER_TEXT_ID = "access-code-expired-error";
export const ACCESS_CODE_MAXLENGTH = 6;
